import type { ComponentNode } from '../../../store/checkoutBuilder/types';
import TextAdapter from './TextAdapter';
import ImageAdapter from './ImageAdapter';
import TimerAdapter from '../adapters/TimerAdapter';

export type RenderOptions = {
  selected: boolean;
  onSelect: () => void;
  onUpdateProps: (patch: Record<string, any>) => void;
  dragHandleProps?: any;
  onDelete?: () => void;
  onDuplicate?: () => void;
};

export function renderComponent(node: ComponentNode, opts: RenderOptions) {
  switch (node.compType) {
    case 'texto':
      return <TextAdapter node={node} {...opts} />;
    case 'imagem':
      return (
        <ImageAdapter
          node={node}
          selected={opts.selected}
          onSelect={opts.onSelect}
          onUpdateProps={opts.onUpdateProps}
          dragHandleProps={opts.dragHandleProps}
          onDelete={opts.onDelete}
          onDuplicate={opts.onDuplicate}
        />
      );
    case 'cronometro':
      return (
        <TimerAdapter
          componentId={node.id}
          selected={opts.selected}
          dragHandleProps={opts.dragHandleProps}
        />
      );
    default:
      return <div className="text-xs text-gray-400">Tipo não suportado: {node.compType}</div>;
  }
}
